<template>
  <span class="badge">
    ({{ total }} record{{ total == 1 ? '' : 's'}})
  </span>
</template>
<script>

export default {
  props:{
    total: Number
  }
}
</script>